const DISPLAY_LOCALES = {
  en: "en-US",
  fr: "fr-FR",
  de: "de-DE",
  es: "es-ES",
  pt: "pt-PT",
  it: "it-IT"
};

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:$|T)/;

export const getDateDisplayLanguage = (language = "fr") =>
  String(language || "fr")
    .toLowerCase()
    .split("-")[0];

export const getDateDisplayLocale = (language) => {
  const normalizedLanguage = getDateDisplayLanguage(language);
  return DISPLAY_LOCALES[normalizedLanguage] || DISPLAY_LOCALES.fr;
};

const toDisplayDate = (value) => {
  if (!value) return null;

  if (typeof value === "string") {
    const dateOnlyParts = value.match(DATE_ONLY_PATTERN);
    if (dateOnlyParts && value.length === 10) {
      const [, year, month, day] = dateOnlyParts;
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/**
 * Formats a date for display only. API values and date calculations must keep
 * using their existing technical format.
 */
export const formatDate = (value, language, options = {}) => {
  const date = toDisplayDate(value);
  if (!date) return options.fallback ?? "";

  const dateTimeFormatOptions = { ...options };
  delete dateTimeFormatOptions.fallback;

  return new Intl.DateTimeFormat(getDateDisplayLocale(language), {
    day: "numeric",
    month: "long",
    year: "numeric",
    ...dateTimeFormatOptions
  }).format(date);
};

export const formatDateRange = (
  startDate,
  endDate,
  language,
  options = {}
) => {
  const start = formatDate(startDate, language, options);
  const end = formatDate(endDate || startDate, language, options);

  if (!start && !end) return options.fallback ?? "";
  if (!start) return `… – ${end}`;
  if (!end || start === end) return start;
  return `${start} – ${end}`;
};
